
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/gdpr",
      function () {
        return require("private-next-pages/compliance/gdpr.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/gdpr"])
      });
    }
  